export const contentSections = {
  research: { path: 'Research', legacy: 'Tags-Detail', api: 'contents', label: 'Research' },
  news: { path: 'News-and-Activities', legacy: 'News-Detail', api: 'events', label: 'News and Activities' },
  tools: { path: 'Tools-and-Services', legacy: 'Tools-Detail', api: 'tools', label: 'Tools and Services' },
  participate: { path: 'Participate-and-Donate', legacy: 'Participate-Detail', api: 'participations', label: 'Participate and Donate' },
  publications: { path: 'Publications', legacy: 'Publications-Detail', api: 'publications', label: 'Publications' },
  students: { path: 'All-Student', legacy: 'Student-Detail', api: 'members', label: 'Student Member' },
};
export function contentName(item) {
  const a = item.attributes || item;
  return [a.name_en || a.title_en || a.title || a.name || a.name_th || a.description_en || a.description, a.surname_en || a.surname_th].filter(Boolean).join(' ').trim();
}
export function contentSlug(item) {
  return contentName(item).normalize('NFKC').trim().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || 'item-' + item.id;
}
export function contentPath(section, item) {
  if (section === 'tools' && item.id === 'fact-or-fake') return '/Tools-and-Services/Fact-or-Fake';
  return '/' + contentSections[section].path + '/' + encodeURIComponent(contentSlug(item));
}
export async function loadContent(section, signal) {
  const items = [];
  for (let page = 1; ; page++) {
    const res = await fetch('https://nx.kmutt.ac.th/api/' + contentSections[section].api + '?pagination[pageSize]=100&pagination[page]=' + page, { signal });
    if (!res.ok) throw new Error('Unable to load content');
    const body = await res.json();
    if (!Array.isArray(body.data)) throw new Error('Invalid content response');
    items.push(...body.data);
    if (page >= (body.meta?.pagination?.pageCount || 1)) return items;
  }
}
